
const INSTALLER_TYPE = 'installateur'

export default {
  name: 'PartnerFittingLink',
  props: {
    vehicle: {
      type: String,
      default: '',
    },
  },
  computed: {
    target() {
      return this.localePath({
        name: 'qui-sommes-nous-partenaires',
        query: { type: INSTALLER_TYPE },
      })
    },
  },
}
